import validate from "validate.js";
export const detailsConstraints = {
    name: {
        length: { minimum: 2 },
        presence: true,
        type: "string",
    },
    password: {
        presence: true,
        type: "string",
        checkPassword: {
            pattern: /^.{8,}$/,
            message: "must be at least 8 characters long",
        },
    },
    companyNo: {
        length: { minimum: 2 },
        presence: true,
        type: "string",
        format: {
            pattern: /^([\da-z]{2})\d{6}$/i,
            message: (value) => validate.format("^%{num} is not a valid company number", {
                num: value,
            }),
        },
    },
};
